import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { Store } from "../Store";
import useAxios from "../hooks/useAxios";
import { getError } from "../utils";
import SepeteEkle from "./SepeteEkle";

export default function ProductsList(props) {
  const axios = useAxios();
  const [productQuantity, setProductQuantity] = useState(1);
  const navigate = useNavigate();
  useState(false);
  const { state } = useContext(Store);
  const { userInfo, carts } = state;
  const {
    tableNum,
    feature,
    product,
    setFeature,
    setFeatures,
    setProduct,
    setQueryByName,
  } = props;

  const updateCartHandler = async (quantity, questions) => {
    try {
      const itemCode = uuidv4();

      const { data } = carts[tableNum - 1].tableCode
        ? { data: carts[tableNum - 1] }
        : await axios.get(`/api/customer?tableNum=${tableNum}`);

      const orderCode = data.orderCode || uuidv4();
      const cartItems = [
        {
          ...product,
          tableCode: data.tableCode,
          orderCode,
          delivered: true,
          quantity,
          createdAt: new Date().toISOString(),
          feature:
            product.features.length === 1 ? product.features[0] : feature,
          tableNum: tableNum,
          itemCode: itemCode,
          questions: questions || [],
          answers:
            questions
              ?.filter((q) => q.answers.filter((a) => a.selected).length > 0)
              .map((q) => ({
                question: q.question,
                questionId: q._id,
                answers: q.answers
                  .filter((a) => a.selected)
                  .map((a) => ({
                    answer: a.answer,
                    answerId: a._id,
                    cost: a.cost,
                    image: a.image,
                    product: a.product,
                    feature: a.feature,
                    firstCost: a.firstCost,
                  })),
              })) || [],
        },
      ];

      await axios.put(`/api/customer/${data.tableCode}`, {
        cartItems,
        customerName: carts[tableNum - 1].description,
        clientCode: userInfo.clientCode,
        orderCode,
        businessOwner:
          userInfo.isHelpDesk && userInfo.client
            ? userInfo.client.businessOwner
            : userInfo.membership.businessOwner,
      });

      toast.success(
        quantity +
          " adet " +
          (feature ? feature.name + " " : "") +
          product.name +
          " sepete eklendi"
      );
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const decrementProductItemHandler = (quantity) => {
    if (
      (product.isHalfPortion && productQuantity > 0.5) ||
      (!product.isHalfPortion && productQuantity > 1)
    ) {
      if (productQuantity - (quantity || 1) > 0) {
        setProductQuantity(productQuantity - (quantity || 1));
      }
    }
  };
  const incrementProductItemHandler = (quantity) => {
    if (
      product.questions?.length > 0 &&
      productQuantity + (quantity || 1) > 1
    ) {
      toast.info(
        "Bu ürün menü olarak tanımlanmış, menü ürünleri sepete bir adet veya yarım porsiyon olarak eklenmelidir!",
        { autoClose: 10000 }
      );
      return;
    }
    setProductQuantity(productQuantity + (quantity ? quantity : 1));
  };

  return (
    <div
      className="bg-white scrollbar scrollbar-primary"
      style={{ overflow: "auto", overflowX: "hidden", height: "100%" }}
    >
      <SepeteEkle
        setFeatures={setFeatures}
        setProduct={setProduct}
        product={product}
        feature={feature}
        decrementProductItemHandler={decrementProductItemHandler}
        productQuantity={productQuantity}
        incrementProductItemHandler={incrementProductItemHandler}
        setFeature={setFeature}
        setQueryByName={setQueryByName}
        setProductQuantity={setProductQuantity}
        updateCartHandler={updateCartHandler}
        navigate={navigate}
      ></SepeteEkle>
    </div>
  );
}
